import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AuthenticationFacade } from '@symphony-solo/domain/authentication/src';
import { CustomerGroupsFacade } from '@symphony-solo/domain/customer-groups/src';
import { LocationFacade } from '@symphony-solo/domain/location/src';
import { map } from 'rxjs/operators';
@Component({
  selector: 'symphony-solo-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainHeaderComponent {
  @Input() public isNameDisplayed = false;
  public selectedCustomerGroup$ = this.customerGroupsFacade.selectedCustomerGroup$.pipe(
    map((customerGroup) => (customerGroup ? customerGroup.name : ''))
  );
  public locationName$ = this.locationFacade.locationName$.pipe(map((locationName) => (locationName ? locationName : '')));
  public userName$ = this.authenticationFacade.userName$;

  public constructor(
    private customerGroupsFacade: CustomerGroupsFacade,
    private locationFacade: LocationFacade,
    private authenticationFacade: AuthenticationFacade
  ) {}
}
